import React, { FC } from 'react';

import { Button, Container, Icon, Page } from 'components';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { theme, useTheme } from 'utils';
import { layoutRoutingUrls } from '../../constants/layout-routing-urls';
import { KASPERSKY_MAIL, LOGOUT_PATH } from 'global-constants';
import DOMPurify from 'isomorphic-dompurify';

const UserIsBlocked: FC = () => {
    const { push } = useHistory();
    const { path } = useRouteMatch();
    const [t] = useTranslation(['translation', 'notifications', 'study-center']);
    useTheme(theme.pageNotFound);

    const goToMainPage = () => {
        const route = Object.values(layoutRoutingUrls).find((item) => ~path.indexOf(item));

        push(route || layoutRoutingUrls.user);
    };

    const logout = () => {
        document.location.href = LOGOUT_PATH;
    };

    return (
        <Page additionalClass="page-content-center">
            <Container>
                <div className="page-not-found-block">
                    <div className="page-not-found-svg">
                        <Icon iconName="not-found-svg" />
                    </div>
                    <h1 className="page-not-found-header">
                        <span
                            className="user-is-blocked"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                    t('notifications:user-is-blocked', {
                                        email: KASPERSKY_MAIL,
                                    })
                                ),
                            }}
                        />
                    </h1>
                    <div className="activates-button">
                        <Button buttonClass="primary" handleClick={goToMainPage}>
                            {t('translation:go-to-main')}
                        </Button>
                        <Button buttonClass="primary" handleClick={logout}>
                            {t('study-center:auth-study-center-logout-btn')}
                        </Button>
                    </div>
                </div>
            </Container>
        </Page>
    );
};

export default UserIsBlocked;
